import { Component, HostListener, Input, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { DaisyDialog, UiModule } from '@app/ui';
import { AppRoutes } from '@app/core/routing';
import { PLATFORM_LOGO_SRC } from '@app/core/site-context';
import { FeatureFlagDirective } from '@app/core/feature-flags';
import { FeatureFlagState } from '@app/state/feature-flags/store/feature-flag.state';
import { Store } from '@ngxs/store';
import { LayoutContext } from '../../../../layout-context.model';
import { HeaderActionsService } from '../../shared/header-actions.service';
import { HeaderPlatformMenuComponent } from '../../shared/header-platform-menu/header-platform-menu.component';
import { HeaderPlatformSearchComponent } from '../../shared/header-platform-search/header-platform-search.component';
import { HeaderSearchDialogComponent } from '../../shared/header-search-dialog/header-search-dialog.component';

@Component({
  selector: 'gb-header-platform',
  standalone: true,
  imports: [RouterLink, HeaderPlatformMenuComponent, HeaderPlatformSearchComponent, UiModule, FeatureFlagDirective],
  templateUrl: './header-platform.component.html',
  styleUrls: ['./header-platform.component.scss'],
  host: {
    '[class.is-transparent]': 'transparent',
  },
})
export class HeaderPlatformComponent {
  @Input() ctx?: LayoutContext;
  @Input() transparent = false;

  private dialog = inject(DaisyDialog);
  private headerActions = inject(HeaderActionsService);
  private store = inject(Store);

  protected readonly AppRoutes = AppRoutes;
  readonly platformLogoSrc = PLATFORM_LOGO_SRC;
  readonly searchEnabled = this.store.selectSignal(FeatureFlagState.isEnabled('header_search_is_enabled'));
  menuOpen = false;

  @HostListener('document:keydown', ['$event'])
  onGlobalKeydown(e: KeyboardEvent): void {
    if (this.searchEnabled() && (e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
      e.preventDefault();
      this.dialog.open(HeaderSearchDialogComponent, {
        width: '860px',
        scrollable: false,
        panelClass: 'search-dialog-panel',
      });
    }
  }

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
  }

  closeMenu(): void {
    this.menuOpen = false;
  }

  fundraiseWithAi(): void {
    this.headerActions.fundraiseWithAi();
  }
}
